import { DealMobileCard } from './DealMobileCard';

export default DealMobileCard;
